import { VersionStore } from '@seedlang/stores';
import Paginator from 'components/paginator';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import SortableColumns from 'components/hoc/sortable_columns';
import cx from 'classnames';
import { Link } from 'react-router';
import Filter from 'components/backend_filter/filter';
@observer
class VersionIndex extends React.Component {
  componentDidMount() {
    VersionStore.getIndex();
  }

  componentWillUnmount() {
    VersionStore.clearIndexData();
  }

  @computed get versions() {
    return VersionStore.indexData;
  }

  render() {
    return (
      <div className='version-index'>
        <Filter
          store={VersionStore}
          defaultSort='-created_at'
          namespace='version-index'
          filters={[
            {
              type: 'select',
              name: 'event',
              options: [{id: 'create', name: 'Create'}, {id: 'update', name: 'Update'}, {id: 'destroy', name: 'Destroy'}],
              labelField: 'name',
              label: 'Event',
              default: '',
            },
            {
              type: 'text',
              name: 'item_id',
              label: 'Item ID',
              placeholder: 'Filter Item ID',
              default: '',
            },
            {
              type: 'text',
              name: 'item_type',
              label: 'Item Type',
              placeholder: 'Filter Item Type',
              default: '',
            },
            {
              type: 'text',
              name: 'user_name',
              label: 'Modified By',
              placeholder: 'Filter Modified By',
              default: '',
            },
          ]}
        />
        <table className='table-wrapper admin-table'>
          <thead>
            <tr>
              <th width='40'></th>
              <th
                className={cx('sortable', this.props.columnClassNames('item_type'))}
                onClick={() => this.props.onSortColumn('item_type')}
              >
                Item Type
              </th>
              <th
                className={cx('sortable', this.props.columnClassNames('event'))}
                onClick={() => this.props.onSortColumn('event')}
              >
                Event
              </th>
              <th
                className={cx('sortable', this.props.columnClassNames('created_at'))}
                onClick={() => this.props.onSortColumn('created_at')}
              >
                Modified At
              </th>
              <th
                className={cx('sortable', this.props.columnClassNames('user_name'))}
                onClick={() => this.props.onSortColumn('user_name')}
              >
                Modified By
              </th>
            </tr>
          </thead>
          <tbody>
            {
              this.versions.map(item => {
                return (
                  <tr key={item.id}>
                    <td>
                      <Link
                        to={{ name: 'builder.versions.show', params: { versionId: item.id } }}
                        className='on-click'
                      >
                        <i className='fa fa-chevron-right fa-block' />
                      </Link>
                    </td>
                    <td>
                      {item.itemType}
                    </td>
                    <td style={{ textTransform: 'capitalize' }}>
                      {item.event}
                    </td>
                    <td>
                      {item.createdAt.formattedDateWithYearAndTime}
                    </td>
                    <td>
                      {item.user?.name || 'Unknown User'}
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
        <Paginator
          store={VersionStore}
        />
      </div>
    );
  }
}

export default SortableColumns(VersionIndex, VersionStore, { sortColumn: 'created_at', sortIsAscending: false });
